import { ContentObjectDetail } from '../content-object-detail';
import { useActivityQuery } from '../queries';

type P = {
  postId: string;
};

const ActivityDetail = ({ postId }: P) => {
  const { data: contentObject, isLoading } = useActivityQuery(postId);

  return <ContentObjectDetail contentObject={contentObject} isLoading={isLoading} />;
};

export default ActivityDetail;
